/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationDto } from '../../models/consultation-dto';
import { ConsultationQuickCreateDto } from '../../models/consultation-quick-create-dto';

export interface ConsultationClientControllerCreateQuickV1$Params {
      body: ConsultationQuickCreateDto
}

export function consultationClientControllerCreateQuickV1(http: HttpClient, rootUrl: string, params: ConsultationClientControllerCreateQuickV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationDto>> {
  const rb = new RequestBuilder(rootUrl, consultationClientControllerCreateQuickV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationDto>;
    })
  );
}

consultationClientControllerCreateQuickV1.PATH = '/api/v1/consultations/client/quick';
